/**
 * Which text machines the open browser can call.
 * Keys come from the operator's env. A public build leaves them unset.
 */

import { geminiComplete, groqComplete, ollamaComplete } from './reelProviders';
import type { TextProvider, WritersRoomDeps } from './writersRoom';

function envValue(name: 'VITE_GROQ_API_KEY' | 'VITE_GEMINI_API_KEY' | 'VITE_AI_SERVER_BASE_URL'): string {
  const value = import.meta.env[name];
  return typeof value === 'string' ? value.trim() : '';
}

/** Groq, then Gemini, then the queue. A missing key is skipped, not a failure. */
export function configuredTextProviders(): TextProvider[] {
  const providers: TextProvider[] = [];
  if (envValue('VITE_GROQ_API_KEY')) providers.push('groq');
  if (envValue('VITE_GEMINI_API_KEY')) providers.push('gemini');
  if (envValue('VITE_AI_SERVER_BASE_URL')) providers.push('ollama');
  return providers;
}

/** The room's `complete` for the running app. Tests pass their own. */
export function createTextCompleter(): WritersRoomDeps['complete'] {
  return (provider, system, user) => {
    if (provider === 'groq') return groqComplete(envValue('VITE_GROQ_API_KEY'), system, user);
    if (provider === 'gemini') return geminiComplete(envValue('VITE_GEMINI_API_KEY'), system, user);
    return ollamaComplete();
  };
}
